import { FC } from 'react';
import { css, Theme } from '@emotion/react';
import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import Input, { InputProps } from '@mui/material/Input';
import { Font, applyEffect, borderRadius } from 'client/Theme';

const inputStyle = (theme: Theme) => css`
  width: 100%;
  font-family: ${Font.body};
  background-color: ${theme.color.grey[60]};
  border-radius: ${borderRadius}px;

  &:hover {
    background-color: ${applyEffect(theme.color.grey[60], 'hover')};
  }

  &.Mui-focused {
    background-color: ${theme.color.primary[60]};
  }

  > .MuiInput-input {
    padding: 8px !important;
  }

  > .MuiInputAdornment-root {
    margin-right: 4px;
  }
`;

export interface SearchableDropdownInputProps extends Omit<AutocompleteRenderInputParams, 'InputProps'> {
  InputProps: Partial<InputProps>;
}

export const SearchableDropdownInput: FC<SearchableDropdownInputProps> = (props) => {
  const { ref: InputRef, ...InputProps } = props.InputProps;

  return (
    <Input
      // An ugly hack to make auto focus work...
      ref={(ref) => {
        if (ref) ((ref as HTMLDivElement).firstChild as HTMLInputElement).focus();
        if (InputRef) (InputRef as any)(ref);
      }}
      inputProps={props.inputProps}
      disableUnderline
      autoFocus
      placeholder="Filter…"
      {...InputProps}
      css={inputStyle}
    />
  );
};
